export default "__VITE_ASSET__B$zTMnof__"